export const openBackUrl = user => {
  const backUrl = user?.backUrl || __CFG__.CUSTOM.BACKURL
  window.open(backUrl, '_top')
}
